import React, { useEffect, useState } from 'react';
import { isSelectStaffing } from '../../api/dashboards-api';
import {
  getOpeningType,
  LEADERSHIP_OPENING,
  setOpeningType,
  STAFFING_ONSITE_OPENING,
  STAFFING_REMOTE_OPENING,
} from '../shared/filters/filter-common';

export const DashboardStaffingFilter = ({ staffingFilterUpdatedCallback }) => {
  const [selectedOpeningType, setSelectedOpeningType] = useState('');

  const onSelect = (event) => {
    const selectedValue = event.target.value;
    setSelectedOpeningType(selectedValue);
    setOpeningType(selectedValue);
    staffingFilterUpdatedCallback();
  };

  useEffect(() => {
    const openingType = getOpeningType();
    if (openingType) {
      setSelectedOpeningType(openingType);
    }
  }, []);

  return (
    <>
      {isSelectStaffing() && (
        <select onChange={(event) => onSelect(event)}>
          <option value={LEADERSHIP_OPENING} selected={selectedOpeningType === LEADERSHIP_OPENING}>
            Leadership
          </option>
          <option value={STAFFING_ONSITE_OPENING} selected={selectedOpeningType === STAFFING_ONSITE_OPENING}>
            Onsite/Hybrid
          </option>
          <option value={STAFFING_REMOTE_OPENING} selected={selectedOpeningType === STAFFING_REMOTE_OPENING}>
            Remote
          </option>
        </select>
      )}
    </>
  );
};
